import React from "react";
import PropTypes from "prop-types";

import { Radio } from "antd";

const propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

const defaultProps = {
  value: null,
};

function RadioGroup(props) {
  return <Radio.Group {...props} />;
}

RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;

export default RadioGroup;
